"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint-disable no-underscore-dangle */

/**
 * 映射无极的表对象类
 */
var Table = /*#__PURE__*/function () {
  function Table(options) {
    (0, _classCallCheck2["default"])(this, Table);
    this.primaryType = -1;
    this._primaryKey = '_id';
    this.key = options.key; // 表所属项目的唯一标识appId

    this.appId = options.appId; // 表的唯一标识schemaId

    this.schemaId = options.schemaId; // 是否主表

    this.isMain = options.isMain; // 表字段的数据过滤条件[无极接口的数据过滤]

    this.queryFilterList = []; // 表的除字段外的基础查询条件[分页、排序等]

    this.queryBaseList = []; // 多表关联的查询时，关联表的关联字段值

    this.queryRelationList = []; // 表的字段schema集

    this.schemaList = []; // 基于表关系树的子节点表对象集合（tableTreeGenerate类填充）

    this.forkTableList = []; // 外部定义的table扩展信息，目前仅用于删除、复制

    this.extendTableInfo = {}; // 批量处理后的请求数据
    // 编辑、删除处理后的附加编辑态，如下
    // data.__isDepend = true: 在新的数据树被引用到的数据
    // 1、data.__changeType = 'edit'：变更的字段都在data.__changeFields（diff edit）
    // 2、data.__changeType = 'add'：变更的字段都在自身data（diff add）
    // --------------
    // data.__isDepend 不存在：等待删除确认的数据（diff 不再引用）
    // 1、data.__changeFields：字段更新信息，用于编辑态的所有字段更新、or 删除态的关联键字段更新
    // 1、data.__changeType = 'delete'：物理真删

    this.dataList = [];
  } // 初始默认没有设置主键，即默认_id


  (0, _createClass2["default"])(Table, [{
    key: "primaryKey",
    get: function get() {
      // 自定义主键是可修改的，直接用_id标记
      if (this.primaryType === 101) {
        return '_id';
      }

      return this._primaryKey;
    },
    set: function set(value) {
      this._primaryKey = value;
    }
  }]);
  return Table;
}();

var _default = Table;
exports["default"] = _default;